// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { BarChart as RawBarChart } from "lucide-react";
export const BarChart = /* @__PURE__ */ createIcon(RawBarChart, "BarChart", 2);
